import { currencies } from "@megaron/catalog-contracts";
import { dateStringSerializer } from "@megaron/date-string";
import { baseDocSerializer } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

import { orderStatuses } from "./orders";

export const orderDocSerializer = Serializers.object({
  ...baseDocSerializer("order").fields,
  number: Serializers.string,
  type: Serializers.stringOneOf("order", "creditMemo"),
  status: Serializers.stringOneOf(...orderStatuses),
  region: Serializers.string.nullable(),
  regionOwnerEmail: Serializers.string.nullable(),
  sellToId: uuidSerializer.nullable(),
  sellToName: Serializers.string.nullable(),
  billToId: uuidSerializer.nullable(),
  billToName: Serializers.string.nullable(),
  orderDate: dateStringSerializer,
  month: Serializers.month,
  createdAt: Serializers.datetime,
  modifiedAt: Serializers.datetime,
  netTotal: Serializers.decimal,
  currency: Serializers.stringOneOf(...currencies),
  profit: Serializers.decimal,
  promisedDeliveryDate: dateStringSerializer.nullable(),
  invoiceNumbers: Serializers.string.array(),
});

export type OrderDoc = SerializerValue<typeof orderDocSerializer>;
